// extracted by mini-css-extract-plugin
export var label = "textarea-module--label--xThrD";
export var textarea = "textarea-module--textarea--G0lvx";